// src/components/common/GlossaryTerm.js
import React from "react";
import { Box, ClickAwayListener, Tooltip, Typography } from "@mui/material";
import { GLOSSARY } from "../../content/glossary";

/** Underlined term with a plain-language explanation (hover, focus or tap). */
export default function GlossaryTerm({ id, children }) {
  const [open, setOpen] = React.useState(false);
  const entry = GLOSSARY[id];
  if (!entry) return children;
  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Tooltip
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        arrow
        enterTouchDelay={0}
        title={
          <Box sx={{ p: 0.5 }}>
            <Typography variant="subtitle2">{entry.term}</Typography>
            <Typography variant="body2">{entry.text}</Typography>
          </Box>
        }
      >
        <Box
          component="span"
          tabIndex={0}
          role="button"
          aria-label={`${entry.term}: ${entry.text}`}
          onClick={() => setOpen((o) => !o)}
          sx={{ borderBottom: "1px dashed", borderColor: "text.secondary", cursor: "help", outlineOffset: 2 }}
        >
          {children || entry.term}
        </Box>
      </Tooltip>
    </ClickAwayListener>
  );
}
